import { memo } from 'react';

import FlexContainer from '@/components/atomic/atoms/layout/flex-container/styled';
import View from '@/components/atomic/atoms/layout/view';
import Cta from '@/components/atomic/atoms/navigation/cta';
import Styled from '@/components/atomic/templates/navigation/welcomebanner/styled';
import withExposer from '@/hocs/with-exposer';
import useVisibleCtas from '@/hooks/use-visible-ctas';
import useStore from '@/state';
import getThirdparty from '@/state/selectors/options/get-thirdparty';
import { WelcomeBannerProps } from '@/typings/components';

const WelcomeBannerComponent: React.FC<WelcomeBannerProps> = ({
	text,
	cta,
}) => {
	const visibleCtas = useVisibleCtas(cta);
	const isThirdParty = useStore(getThirdparty);

	if ((!text && !visibleCtas) || isThirdParty) return null;

	return (
		<Styled>
			<FlexContainer>
				<View>
					{text ? <span>{text}</span> : null}
					{visibleCtas ? (
						<Cta
							ariaLabel={visibleCtas.ariaLabel}
							link={visibleCtas.link}
							linkType={visibleCtas.linkType}
							target={visibleCtas.target}
							text={visibleCtas.text}
						/>
					) : null}
				</View>
			</FlexContainer>
		</Styled>
	);
};

const WelcomeBanner = memo(
	withExposer(WelcomeBannerComponent, 'welcomebanner'),
);

export default WelcomeBanner;
